import styled from "styled-components";

export const BannerDiv = styled.div`
  width: ${({ theme }) => theme.wrapperWidth};
  margin: 1.5rem auto 0 auto;
`;

export const Banner = styled.img`
  width: 100%;
  border-radius: 0.5rem;
`;
